<template>
  <button type="button"
          class="navbar-toggler"
          :class="{toggled: toggled}"
          data-toggle="collapse"
          data-target="#navbar"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
          >
    <span class="navbar-toggler-bar top-bar" :style="{ backgroundColor: buttonColor }"></span>
    <span class="navbar-toggler-bar middle-bar" :style="{ backgroundColor: buttonColor }"></span>
    <span class="navbar-toggler-bar bottom-bar" :style="{ backgroundColor: buttonColor }"></span>
  </button>
</template>
<script>
    export default {
      name: 'navbar-toggle-button',
      props: {
        buttonColor: String,
        toggled: Boolean
      }
    }
</script>
<style>
  .button-bar{
      color: black;
  }
</style>
